import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07d9c5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-label-icon-container" }
const _hoisted_2 = {
  key: 1,
  class: "ai-button-container"
}
const _hoisted_3 = {
  key: 0,
  class: "sub-label"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-arrow-up-right-from-square" }, null, -1))

import { PropType, computed, onMounted, onUnmounted, ref, watch } from "vue";
import { DxButton, DxValidator } from "devextreme-vue";
import { DxTextArea } from "devextreme-vue";
import { validationCallback } from "@/utils/validation/FieldValidator";
import { DxCustomRule, DxRequiredRule } from "devextreme-vue/validator";
import { FieldValidation } from "acquaint-api/validation/FieldValidation";
import { FieldSize } from "@/enums/system/FieldSize";
import { ValidatedEvent } from "devextreme/ui/validator";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import AcquaintPopoutTextArea from "@/components/ui/inputs/acquaint-popout-text-area.vue";
import { sizes, subscribe, unsubscribe } from "@/utils/media-query";


export default /*#__PURE__*/_defineComponent({
  __name: 'acquaint-text-area',
  props: {
  /**
   * The validation rules applied to the field.
   * @type {FieldValidation}
   * @required
   */
  fieldValidation: {
    type: Object as PropType<FieldValidation>,
    required: true,
  },
  /**
   * The string value used with `v-model` to control the visibility or state of a modal or component.
   * @type {string}
   * @required
   */
  modelValue: {
    type: String,
    required: true,
  },
  /**
   * The height of the component, specified as a CSS string.
   * @type {string}
   * @default '9rem'
   */
  height: {
    type: String,
    default: "9rem",
  },
  /**
   * The width of the field, defined by the `FieldSize` enum.
   * @type {FieldSize}
   * @default FieldSize.Full
   */
  width: {
    type: String as PropType<FieldSize>,
    default: FieldSize.Full,
  },
  /**
   * Determines whether the specific control is read only.
   * @type {boolean}
   * @default false
   */
  readOnly: {
    type: Boolean,
    default: false,
  },
  /**
   * Custom validation function for the field.
   * @type {Function}
   * @optional
   */
  customValidation: {
    type: Function,
    required: false,
  },
  /**
   * The message displayed when validation fails.
   * @type {string}
   * @optional
   */
  invalidMessage: {
    type: String,
    required: false,
  },
  /**
   * The label displayed for the control.
   * @type {String}
   * @default ''
   */
  label: {
    type: String,
    default: "",
  },
  /**
   * The subLabel displayed for the control.
   * @type {String}
   * @default ''
   */
  subLabel: {
    type: String,
    default: "",
  },
  /**
   * The event type that triggers a value change.
   * @type {TextboxValueChangeEvent}
   * @default TextboxValueChangeEvent.Change
   */
  valueChangeEvent: {
    type: String as PropType<TextboxValueChangeEvent>,
    default: TextboxValueChangeEvent.KeyUp,
  },
  /**
   * Determines whether the specific input control is focused.
   * @type {boolean}
   * @default false
   */
  focusInput: {
    type: Boolean,
    default: false,
  },
  /**
   * Determines whether it should reset valid flag.
   * @type {boolean}
   * @default false
   */
  resetValid: {
    type: Boolean,
    default: false,
  },
  /**
   * The unique identifier for the container.
   * @type {string}
   * @default undefined
   */
  containerId: {
    type: String,
    default: undefined,
  },
  /**
   * Determines whether to display AI modal.
   * @type {boolean}
   * @default false
   */
  displayAIModal: {
    type: Boolean,
    default: false,
  },
  /**
   * The validation group identifier for managing form validations.
   * @type {string}
   * @default ''
   */
  validationGroup: {
    type: String,
    default: "",
  },
  /**
   * Determines whether to capitalize the first letter of each word.
   * @type {boolean}
   * @default false
   */
  capitalizeWord: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "update:modelValue",
  "onOptionChanged",
  "aiIconClick",
],
  setup(__props, { emit }) {

const props = __props;



const validationErrors = ref("");
const isValid = ref(true);
const textArea = ref<InstanceType<typeof DxTextArea | null>>(null);
const displayPopoutModal = ref(false);
const wrapperRef = ref<HTMLElement | null>(null);
const hasScrollbar = ref(false);
const isMobile = ref(false);

onMounted(() => {
  updateIsMobile();
  subscribe(updateIsMobile);
});

onUnmounted(() => {
  unsubscribe(updateIsMobile);
});

const updateIsMobile = () => {
  const breakpoints = sizes();
  isMobile.value = breakpoints["screen-x-small"] === true;
};

const value = computed({
  get: () => props.modelValue,
  set: (val: string) => emit("update:modelValue", val),
});



watch(
  () => props.resetValid,
  () => {
    if (props.resetValid) {
      isValid.value = true;
      return;
    }
  },
);

/** Custom validation configuration to override DevExpress default validation method */
const adapterConfig = {
  getValue: () => {
    return value.value;
  },
  applyValidationResults: (e: ValidatedEvent) => {
    if (props.resetValid) {
      isValid.value = true;
      return;
    }
    isValid.value = !!e.isValid;

    // Construct list of validation errors to be displayed to the user when they hover over the field
    validationErrors.value =
      !e.isValid && e.brokenRule?.message ? e.brokenRule.message : "";
  },
  validationRequestsCallbacks: [],
};

watch(
  () => props.focusInput,
  () => {
    if (!props.focusInput) {
      return;
    }

    textArea.value?.instance?.focus();
  },
);

const onOptionChanged = (e: any) => {
  emit("onOptionChanged", e.value);
};

const onFocusOut = () => {
  value.value = value.value.trim();
  if (props.capitalizeWord) {
    value.value = toTitleCase(value.value);
  }
};

watch(value, () => {
  setTimeout(() => {
    checkScrollbar();
  }, 5);
});

const checkScrollbar = () => {
  if (!wrapperRef.value) return;
  const el = wrapperRef.value.querySelector(
    ".dx-textarea textarea",
  ) as HTMLElement;
  if (!el) return;
  hasScrollbar.value = el.scrollHeight > el.clientHeight;
};

const toTitleCase = (str: string): string => {
  if (!str) return str;

  return str
    .toLowerCase()
    .replace(/(^|\s)\w/g, (letter) => letter.toUpperCase());
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["label", { asteriskVisible: __props.fieldValidation.isRequired }])
          }, _toDisplayString(__props.label), 3))
        : _createCommentVNode("", true),
      (props.displayAIModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("i", {
              class: "fa-sharp fa-thin fa-microchip-ai ai-button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('aiIconClick')))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.subLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.subLabel), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      id: __props.containerId,
      class: "textbox-container textarea-wrapper",
      ref_key: "wrapperRef",
      ref: wrapperRef
    }, [
      _createVNode(_unref(DxTextArea), {
        ref_key: "textArea",
        ref: textArea,
        value: value.value,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
        "max-length": __props.fieldValidation.maxLength,
        height: __props.height,
        width: __props.width,
        "read-only": props.readOnly,
        "is-valid": isValid.value,
        hint: validationErrors.value,
        valueChangeEvent: __props.valueChangeEvent,
        onOptionChanged: onOptionChanged,
        onFocusOut: onFocusOut
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxValidator), {
            adapter: adapterConfig,
            "validation-group": __props.validationGroup
          }, {
            default: _withCtx(() => [
              (__props.fieldValidation.isRequired)
                ? (_openBlock(), _createBlock(_unref(DxRequiredRule), { key: 0 }))
                : _createCommentVNode("", true),
              (props.customValidation)
                ? (_openBlock(), _createBlock(_unref(DxCustomRule), {
                    key: 1,
                    reevaluate: true,
                    "validation-callback": __props.customValidation,
                    message: props.invalidMessage
                  }, null, 8, ["validation-callback", "message"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(DxCustomRule), {
                fieldValidation: __props.fieldValidation,
                "validation-callback": _unref(validationCallback),
                reevaluate: true
              }, null, 8, ["fieldValidation", "validation-callback"])
            ]),
            _: 1
          }, 8, ["validation-group"])
        ]),
        _: 1
      }, 8, ["value", "max-length", "height", "width", "read-only", "is-valid", "hint", "valueChangeEvent"]),
      (!props.readOnly)
        ? (_openBlock(), _createBlock(_unref(DxButton), {
            key: 0,
            class: _normalizeClass(["textarea-icon", { 'with-scrollbar': hasScrollbar.value && !isMobile.value }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (displayPopoutModal.value = true))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["class"]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_4),
    _createVNode(AcquaintPopoutTextArea, {
      modelValue: displayPopoutModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((displayPopoutModal).value = $event)),
      content: value.value,
      "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((value).value = $event)),
      label: props.label,
      displayAIButton: props.displayAIModal
    }, null, 8, ["modelValue", "content", "label", "displayAIButton"])
  ], 64))
}
}

})